// Rivio – MenuDrawer override

// Via event delegation zodat timing van script-laden geen rol speelt.
document.addEventListener('click', (event) => {
  const closeBtn = event.target.closest('.mobile-facets__close');
  if (!closeBtn) return;

  const menuDrawer = closeBtn.closest('menu-drawer');
  if (!menuDrawer) return;

  // Roep closeMenuDrawer aan op de MenuDrawer instantie
  menuDrawer.closeMenuDrawer(event, menuDrawer.mainDetailsToggle.querySelector('summary'));
});

function initStickyFilter() {
  const sentinel = document.querySelector('#filter-sentinel');
  const wrapper = document.querySelector('.mobile-facets__wrapper');

  if (!sentinel || !wrapper) return;

  const observerOptions = {
    root: null,
    threshold: 0,
    // Pas de -80px aan naar de hoogte van je header + 20px marge
    // Syntax: "top right bottom left"
    rootMargin: '-80px 0px 0px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // We checken of de sentinel boven de 'magische lijn' van -80px is gekomen
      const isPastThreshold = entry.boundingClientRect.top < 80; // Match met je rootMargin

      if (!entry.isIntersecting && isPastThreshold) {
        wrapper.classList.add('is-sticky');
      } else {
        wrapper.classList.remove('is-sticky');
      }
    });
  }, observerOptions);

  observer.observe(sentinel);
}

document.addEventListener('DOMContentLoaded', initStickyFilter);
document.addEventListener('shopify:section:load', initStickyFilter);